var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viweBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 105A50 50 0 1 0 55 5a50 50 0 0 0 0 100Z",
    fill: "#FFDA7C",
    stroke: "#fff",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2 31a5.5 5.5 0 0 1 4-1.8c1.1 0 2.2 0 3.3.3.7.2 1.3.5 1.8.8.5.4.8 1 1 1.5.3 1.3.4 2.5.4 3.8v39l-.1 2.4-.7 1.8c-.7 1.3-2.5 2-5.5 2-2.9 0-4.7-.7-5.4-1.9-.3-.6-.5-1.2-.6-2-.1-.8-.2-1.6-.1-2.5v-25l-1 .9c-1.9 1.4-3.5 2.1-4.9 2.1-1.3 0-2.7-.8-4.2-2.4-1.5-1.7-2.2-3.1-2.2-4.4 0-1.2.8-2.6 2.5-4L52 31h.2Z",
    fill: "#F36A7D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.0696b83a2727361cf190e4d71a5be535.svg";
export { ForwardRef as ReactComponent };